import { render, staticRenderFns } from "./OnTdb.vue?vue&type=template&id=76db71af&"
import script from "./OnTdb.vue?vue&type=script&lang=js&"
export * from "./OnTdb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports